import React from "react";

import BaseIcon from "../BaseIcon";

const HomeTDLogo = props => (
  <BaseIcon viewBox="0 0 40 40" {...props}>
    <defs>
      <path
        id="a"
        d="M20 9.632L9.2 18.096v12.272h7.2v-7.5h7.2v7.5h7.2V18.096z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#20AFF0" cx="20" cy="20" r="20"></circle>
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#000" xlinkHref="#a" />
      <path fill="#fff" mask="url(#b)" d="M0 0h40v40H0z" />
    </g>
  </BaseIcon>
);

export default HomeTDLogo;
